import React, { Component } from "react";
import { Modal, Select, Popconfirm, message } from "antd";
import { router } from "umi";
import { connect } from "dva";
import ListPage from "@/Components/ListPage";
import OperateDropdown from "@/components/OperateDropdown";
import styles from "./index.less";
import { GetQueryString } from "../../../../../../utils/utils";

const { ListTable, ListCreate } = ListPage;

@connect(({ projectCriterion, projectTarget }) => ({
  spinProps: projectCriterion.spinProps,
  respondentOrgList: projectCriterion.respondentOrgList,
  pageInfo: projectCriterion.pageInfo,
  targetList: projectTarget.respondentOrgList
}))
class PersonalTab extends Component {
  constructor(props) {
    super(props);
    this.projectId = GetQueryString("currentProjectId");
    this.state = {
      showModal: false,
      nowOrgId: ""
    };
  }

  componentDidMount() {
    this.handleGetDataList();
  }

  // 展示新增学校modal
  handleShowModal = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "projectTarget/fetchRespondentList",
      payload: {
        page: 1,
        pageSize: 99999999,
        projectId: this.projectId
      },
      callback: () => {
        this.setState({
          showModal: true
        });
      }
    });
  };

  // 隐藏学校modal
  handleCloseModal = () => {
    this.setState({
      showModal: false
    });
  };

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const pageInfo = { page, pageSize };
    this.handleCallBack(pageInfo);
  };

  handleGetDataList = pageInfo => {
    const { dispatch } = this.props;
    dispatch({
      type: "projectCriterion/fetchPersonalOrgList",
      payload: {
        page: 1,
        pageSize: 10,
        projectId: this.projectId,
        ...pageInfo
      }
    });
  };

  // 修改选中下拉框条目
  handleSelect = (val, record) => {
    const { key } = record;
    this.setState({
      nowOrgId: val,
      nowOrgName: key
    });
  };

  // 增加学校
  handleAddOrg = () => {
    const { dispatch } = this.props;
    const { nowOrgId, nowOrgName } = this.state;
    this.setState({
      showModal: false
    });
    dispatch({
      type: "projectCriterion/fetchAddOrg",
      payload: {
        projectId: this.projectId,
        respondOrgList: [
          {
            orgId: nowOrgId,
            orgName: nowOrgName
          }
        ]
      },
      callback: this.handleGetDataList
    });
  };

  // 删除某个条目
  handleDelete = value => {
    const { orgId } = value;
    const { dispatch } = this.props;
    dispatch({
      type: "projectCriterion/fetchDeleteOrg",
      payload: {
        orgIds: [orgId],
        projectId: this.projectId
      },
      callback: this.handleGetDataList
    });
  };

  // 跳转页面
  routerJump = value => {
    const { orgName, orgId } = value;
    router.push(
      `/supervision/norm/project/overview/criterion/personalSettings?respondentOrgId=${orgId}&respondentOrgName=${orgName}&currentProjectId=${this.projectId}`
    );
  };

  // 表格部分
  renderTableContent = () => {
    const { spinProps, pageInfo, respondentOrgList } = this.props;
    const pageProps = {
      className: "personalNormTable",
      spinProps
    };

    const createProps = {
      btnText: "新增学校",
      onCreate: this.handleShowModal
    };

    const tableProps = {
      rowKey: "id",
      list: respondentOrgList || [],
      pageInfo,
      onPageChange: this.handlePaginationChange,
      columns: [
        { title: "学校名称", dataIndex: "orgName", key: "orgName" },
        {
          title: "操作",
          key: "operation",
          fixed:'right',
          render: value => {
            const data = [
              {
                text: <a onClick={() => this.routerJump(value)}>指标设置</a>
              },
              {
                text: (
                  <Popconfirm
                    title="确认删除?"
                    onConfirm={() => {
                      this.handleDelete(value);
                    }}
                    okText="确定"
                    cancelText="取消"
                  >
                    删除
                  </Popconfirm>
                )
              }
            ];
            return <OperateDropdown data={data} />;
          }
        }
      ]
    };

    return (
      <ListPage {...pageProps}>
        <ListCreate {...createProps} />
        <ListTable {...tableProps} />
      </ListPage>
    );
  };

  // 弹框部分
  renderModal = () => {
    const { showModal } = this.state;
    const { targetList } = this.props;

    const modalProps = {
      title: "新增学校",
      onCancel: this.handleCloseModal,
      onOk: this.handleAddOrg,
      visible: showModal,
      wrapClassName: "newSchoolContainer"
    };

    const selectProps = {
      placeholder: "请选择",
      onSelect: this.handleSelect
    };

    return (
      <Modal {...modalProps}>
        <div className="selectContainer">
          <div className="schoolName">学校名称：</div>
          <Select {...selectProps}>
            {targetList?.map(item => {
              return (
                <Select.Option value={item?.orgId} key={item?.orgName}>
                  {item.orgName}
                </Select.Option>
              );
            })}
          </Select>
        </div>
      </Modal>
    );
  };

  render() {
    return (
      <div className={styles.root}>
        {this.renderTableContent()}
        {this.renderModal()}
      </div>
    );
  }
}

export default PersonalTab;
